import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  
    SuiSidebarModule,
    SuiSelectModule, 
    SuiDatepickerModule,
    SuiPopupModule,
    SuiCheckboxModule,
    SuiDropdownModule,
    SuiPaginationModule,
    SuiAccordionModule,
    SuiModalModule,
    SuiModule ,
    SuiCollapseModule,

} from 'ng2-semantic-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationComponent } from './pagination/pagination.component';
import { DailyAlertComponent } from './daily-alert/daily-alert.component';

import { AttendanceRecService } from './services/attendance-record.service';
import { BreakService } from './services/breaks.service';
import { TemplateSetService } from './services/template-set.service';
import { IndiSetService } from './services/indi-set.service';
import { BasicSettingsService } from '../basic-settings/shared/basic-settings.service';
import { WorkRecListService } from '../workrec-list/shared/workrec-list.service';
import { AlertApplicationService } from '../alert-application/shared/alert-application.service';
import { AuthGuard } from '../login/shared/auth.guard';
import { AdminGuard } from '../login/shared/admin.guard';
import { TimestampCebuGuard } from '../timestamp-cebu/shared/timestampcebu.guard';
import { TimestampCebuService } from '../timestamp-cebu/shared/timestamp-cebu.service';
import { CebuVacationsService } from './services/cebu-vacations.service';
import { LeaderGuard } from '../login/shared/leader.guard';
import { BreaktimecebuGuard } from '../breaktime-cebu/shared/breaktimecebu.guard';
import { BreaktimeCebuService } from '../breaktime-cebu/shared/breaktime-cebu.service';
import { StaffService } from './services/staff.service';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SuiSidebarModule,
        SuiSelectModule, 
        SuiDatepickerModule,
        SuiPopupModule,
        SuiCheckboxModule,
        SuiDropdownModule,
        SuiPaginationModule,
        SuiAccordionModule,
        SuiModalModule,
        SuiModule,
        SuiCollapseModule
    ],
    declarations: [
        PaginationComponent,
        DailyAlertComponent
    ],
    exports: [
        PaginationComponent,
        DailyAlertComponent,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SuiSidebarModule,
        SuiSelectModule, 
        SuiDatepickerModule,
        SuiPopupModule,
        SuiCheckboxModule,
        SuiDropdownModule,
        SuiPaginationModule,
        SuiAccordionModule,
        SuiModalModule,
        SuiModule,
        SuiCollapseModule
    ],
    providers: [
        AttendanceRecService,
        BreakService,
        TemplateSetService,
        IndiSetService,
        BasicSettingsService,
        WorkRecListService,
        AlertApplicationService,
        AuthGuard,
        AdminGuard,
        LeaderGuard,
        TimestampCebuService,
        TimestampCebuGuard,
        CebuVacationsService,
        BreaktimecebuGuard,
        BreaktimeCebuService,
        StaffService
    ]

})

export class SharedModule { }